'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.updateDokumentFilter_164779v1 = updateDokumentFilter_164779v1;
exports.updateMapDokumentFilter_164779v1 = updateMapDokumentFilter_164779v1;
exports.updateListDokumentFilter_164779v1 = updateListDokumentFilter_164779v1;
exports.updateTypDokument_8E5AECv1 = updateTypDokument_8E5AECv1;
exports.updateMapTypDokument_8E5AECv1 = updateMapTypDokument_8E5AECv1;
exports.updateListTypDokument_8E5AECv1 = updateListTypDokument_8E5AECv1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:58:29Z                      #

// ##############################################################

function updateDokumentFilter_164779v1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'DokumentFilterVO'
    });

    return result;
}

function updateMapDokumentFilter_164779v1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateDokumentFilter_164779v1(data[key]);
    });
    return result;
}

function updateListDokumentFilter_164779v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDokumentFilter_164779v1);
}

function updateTypDokument_8E5AECv1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'TypDokumentVO'
    });

    return result;
}

function updateMapTypDokument_8E5AECv1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateTypDokument_8E5AECv1(data[key]);
    });
    return result;
}

function updateListTypDokument_8E5AECv1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateTypDokument_8E5AECv1);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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